import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../../context/Translator";
import axios from "axios";
import { Row, Col, Form, Table } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Link, useNavigate } from "react-router-dom";
import { FiSearch, FiEye, FiAlertTriangle } from "react-icons/fi";

/**
 * TEMPORARY (until a real backend exists): stock items are read from the
 * same localStorage key that Purchase Entry writes to on Final Submit,
 * so anything added there shows up here automatically.
 */
// const STOCK_STORAGE_KEY = "dummy_stock_items";

// function readStockFromStorage() {
//     try {
//         return JSON.parse(localStorage.getItem(STOCK_STORAGE_KEY) || "[]");
//     } catch {
//         return [];
//     }
// }


/**
 * Stock Index — per-item view
 * Mirrors the Purchase Entry data model: every row is a single physical
 * piece (parent product -> child product, with weight & stone details),
 * not an aggregated quantity/category. An item is either "In Stock" or
 * "Sold" — there is no separate low-stock alert at this granularity.
 */
export default function StockIndex() {
    const { t } = useContext(TranslatorContext);
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        fetchStock();
    }, []);
    //GET API 
    const fetchStock = async() => {
        try {
            setLoading(true);
        const token = localStorage.getItem('authToken');

        const res =await axios.get(`${process.env.REACT_APP_API_URL}/stock`,{
            headers:{
                Authorization:`Bearer {token}`,
            }
        });
        if(res.data.status)
        {
            setData(res.data.items ||[])
        }else{
            setData([])
        }
        } catch (error) {
            console.error(error);
            setData([])
        }finally{
            setLoading(false)
        }

        // --- LOCALSTORAGE DATA (remove once backend /stock endpoint is ready) ---
        // setTimeout(() => {
        //     setData(readStockFromStorage());
        //     setLoading(false);
        // }, 200);
        // return;

        // --- REAL API CALL (uncomment when backend is ready) ---
        // const token = localStorage.getItem("authToken");
        // axios.get(`${process.env.REACT_APP_API_URL}/stock`, {
        //     headers: {
        //         Authorization: `Bearer ${token}`
        //     }
        // })
        //     .then(res => {
        //         setData(res.data.status ? (res.data.items || []) : []);
        //     })
        //     .catch(err => console.error(err))
        //     .finally(() => setLoading(false));
    };

    const handleViewItem = (itemId) => {
        navigate(`/stock/show/${itemId}`);
    };

    // Filter by parent/child product name
    // Filter by parent/child product name and vendor
    const filteredData = data.filter(item => {
        const haystack = `${item.parent_product_name || ""} ${item.child_product_name || ""} ${item.vendor_name || ""}`.toLowerCase();
        return haystack.includes(searchTerm.toLowerCase());
    });

    if (loading) {
        return (
            <PageLayout>
                <div className="text-center p-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">{t("loading")}...</span>
                    </div>
                    <p className="mt-3">{t("loading")}...</p>
                </div>
            </PageLayout>
        );
    }

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-breadcrumb p-3">
                            <h3 className="mc-breadcrumb-title mb-0">{t('stock management')}</h3>
                            <ul className="mc-breadcrumb-list mb-0">
                                <li className="mc-breadcrumb-item">
                                    <Link to="#" className="mc-breadcrumb-link" style={{ color: '#C9A227' }}>{t('home')}</Link>
                                </li>
                                <li className="mc-breadcrumb-item" style={{ color: '#C9A227' }}>
                                    <Link to="#" className="mc-breadcrumb-link" style={{ color: '#C9A227' }}>{t('inventory')}</Link>
                                </li>
                                <li className="mc-breadcrumb-item" >{t('stock')}</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                <Col xl={12}>
                    <div className="mc-card">
                        {/* Header with Search */}
                        <div className="d-flex justify-content-between align-items-center p-3 border-bottom flex-wrap gap-3">
                            <h5 className="mb-0">{t('stock list')}</h5>

                            <div className="position-relative">
                                <Form.Control
                                    type="text"
                                    size="sm"
                                    placeholder={t('search products...')}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{ paddingRight: '35px', width: '250px' }}
                                />
                                <FiSearch className="position-absolute top-50 end-0 translate-middle-y me-2 text-muted" size={16} />
                            </div>
                        </div>

                        <div className="table-responsive-wrapper">
                            <Table responsive hover className="table mb-0 stock-table">
                                <thead >
                                    <tr >
                                        <th className="text-center" >#</th>
                                        <th >{t('image')}</th>
                                        <th >{t('product')}</th>
                                        <th >{t('vendor')}</th>
                                        <th className="text-center" >{t('qty')}</th>
                                        <th className="text-center" >{t('net / pure wt.')}</th>
                                        <th >{t('stone')}</th>
                                        <th className="text-center" >{t('status')}</th>
                                        <th className="text-center" >{t('actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((item, index) => (
                                            <tr key={item.id}>
                                                <td className="text-center">{index + 1}</td>
                                                <td>
                                                    {item.image ? (
                                                        <img
                                                            src={item.image}
                                                            alt={item.child_product_name || item.parent_product_name}
                                                            style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 6 }}
                                                        />
                                                    ) : (
                                                        <div
                                                            className="d-flex align-items-center justify-content-center bg-light text-muted"
                                                            style={{ width: 40, height: 40, borderRadius: 6 }}
                                                        >
                                                            —
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    <strong>{item.parent_product_name}</strong>
                                                    {item.child_product_name && (
                                                        <div className="text-muted small">{item.child_product_name}</div>
                                                    )}
                                                </td>
                                                <td>{item.vendor_name || '-'}</td>
                                                <td className="text-center">{item.qty || 1}</td>
                                                <td className="text-center">
                                                    <span className="badge bg-info text-white px-2 py-1">
                                                        {Number(item.net_weight || 0).toFixed(3)}g / {Number(item.pure_weight || 0).toFixed(3)}g
                                                    </span>
                                                </td>
                                                <td>{item.stone_type || '-'}</td>
                                                <td className="text-center">
                                                    {item.status === 'sold' ? (
                                                        <span className="badge bg-secondary px-3 py-2">{t('sold')}</span>
                                                    ) : (
                                                        <span className="badge bg-success px-3 py-2">{t('in stock')}</span>
                                                    )}
                                                </td>
                                                <td className="text-center">
                                                    <div className="mc-table-action justify-content-center">
                                                        <button
                                                            className="material-icons view"
                                                            onClick={() => handleViewItem(item.id)}
                                                            title={t('View Item Details')}
                                                            style={{
                                                                background: 'none',
                                                                border: 'none',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            <FiEye />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        
                                        <tr>
                                            <td colSpan="9" className="text-center py-5">
                                                <div className="empty-state">
                                                    <FiAlertTriangle size={48} className="text-muted mb-2" />
                                                    <p className="text-muted mb-0">{t('no stock data found')}</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}

